import createReducer from 'core/store/createReducer';
import {
  RESOURCE,
  RECORD_FIELD,
  updateResourceState
} from 'react-structure-admin';

import {
  SUBSCRIPTION,
  SUBSCRIPTION_CURRENT_GET,
  SUBSCRIPTION_CURRENT_GET_FINISHED,
  SUBSCRIPTION_SET_LOADING,
  SUBSCRIPTION_SET_VALUES,
  SUBSCRIPTION_UPDATE,
  SUBSCRIPTION_UPDATE_FINISHED,
  SUBSCRIPTION_OPEN_PURCHASE_PACKAGE,
  SUBSCRIPTION_CLOSE_PURCHASE_PACKAGE,
  SUBSCRIPTION_PURCHASE_PACKAGE,
  SUBSCRIPTION_PURCHASE_PACKAGE_FINISHED,
  SUBSCRIPTION_BALANCE_DETAILS,
  SUBSCRIPTION_BALANCE_DETAILS_FINISHED,
  SUBSCRIPTION_OPEN_PACKAGE_LIST,
  SUBSCRIPTION_CLOSE_PACKAGE_LIST
} from './subscriptionActions';

const handleError = (state, action) => {
  return {
    ...state,
    saving: false,
    loading: false,
    canceling: false,
    buyingPackage: false
  };
};

const subscriptionReducer = createReducer(
  SUBSCRIPTION,
  [],
  {
    [SUBSCRIPTION_CURRENT_GET](state, action) {
      return {
        ...state,
        subscription: null,
        loading: true,
        plans: false
      };
    },

    [SUBSCRIPTION_CURRENT_GET_FINISHED](state, action) {
      return {
        ...state,
        subscription: action.payload.data.result,
        loading: false,
        plans: false
      };
    },

    [SUBSCRIPTION_SET_VALUES](state, action) {
      if (!state[RECORD_FIELD]) {
        state[RECORD_FIELD] = {};
      }

      return {
        ...state,
        [RECORD_FIELD]: {
          ...state[RECORD_FIELD],
          ...action.payload
        },
        loading: false
      };
    },

    [SUBSCRIPTION_SET_LOADING](state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },

    [SUBSCRIPTION_OPEN_PURCHASE_PACKAGE](state, action) {
      return {
        ...state,
        purchasePackage: true
      };
    },

    [SUBSCRIPTION_CLOSE_PURCHASE_PACKAGE](state, action) {
      return {
        ...state,
        purchasePackage: false
      };
    },

    [SUBSCRIPTION_PURCHASE_PACKAGE](state, action) {
      return {
        ...state,
        buyingPackage: true
      };
    },

    [SUBSCRIPTION_PURCHASE_PACKAGE_FINISHED](state, action) {
      return {
        ...state,
        buyingPackage: false,
        purchasePackage: false
      };
    },

    [SUBSCRIPTION_BALANCE_DETAILS](state, action) {
      return {
        ...state,
        balanceDetails: {}
      };
    },

    [SUBSCRIPTION_BALANCE_DETAILS_FINISHED](state, action) {
      return {
        ...state,
        balanceDetails: action.payload.data.result
      };
    },

    [SUBSCRIPTION_OPEN_PACKAGE_LIST](state, action) {
      return {
        ...state,
        packageList: true
      };
    },

    [SUBSCRIPTION_CLOSE_PACKAGE_LIST](state, action) {
      return {
        ...state,
        packageList: false
      };
    },

    [SUBSCRIPTION_UPDATE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        saving: true
      }));
    },

    [SUBSCRIPTION_UPDATE_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        subscription: action.payload.data.result,
        plans: false,
        saving: false
      }));
    }
  },
  handleError
);

export default subscriptionReducer;
